import { readerLanguage, readerLanguageCode, translatedPageText } from './readerTranslation';
export const SPEECH_API = 'https://azuretts.fictiongenie.com';
export async function requestStoryNarration(client, sourceText, fileName, language) {
  const targetLanguage = readerLanguage(language);
  const response = await client.post(`${SPEECH_API}/generate-speech`, {
    text: sourceText, fileName, targetLanguage, language: targetLanguage, multiVoice: true, emotion: 'Dynamic'
  }, { headers: { 'Content-Type': 'application/json' }, timeout: 300000 });
  const data = response.data;
  if (response.status !== 200 || data?.format !== 'wav' || !data.audioUrl || readerLanguage(data.language) !== targetLanguage) throw new Error('The narration API did not return the requested language and WAV audio.');
  const text = translatedPageText({ status: 200, data: { data: { translatedContent: data.translatedText } } }, sourceText, readerLanguageCode(targetLanguage));
  const url = new URL(data.audioUrl, SPEECH_API);
  if (url.origin !== SPEECH_API || !url.pathname.toLowerCase().endsWith('.wav')) throw new Error('The narration API did not return a valid WAV URL.');
  return { text, rawText: sourceText, audioUrl: url.href };
}
